import { render, staticRenderFns } from "./001_Jahr_1986.vue?vue&type=template&id=3e5e0002&"
import script from "./001_Jahr_1986.vue?vue&type=script&lang=js&"
export * from "./001_Jahr_1986.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports